export function handleLinkClick(url) {
    const urlObj = new URL(url);
    const validHostnames = ['members.teamrwb.org', 'members-staging.teamrwb.org', 'members-test.teamrwb.org', 'localhost'];
    if (validHostnames.includes(urlObj.hostname)) {
        window.open(url, "_self");
    }
    else {
        window.open(url, '_blank');
    }
}